export default {
    namespaced: true,

    state: () => {
        return {
            data: {
                resubmitRoute: null,
                invalidApplicants: [],
                validationErrorResponse: null,
            },
        }
    },

    mutations: {
        setResubmitRoute(state, route) {
            state.data.resubmitRoute = {
                name: route.name,
                path: route.path,
                params: route.params,
            }
        },

        setInvalidApplicants(state, applicants) {
            state.data.invalidApplicants = applicants
        },

        setValidationErrorResponse(state, response) {
            state.data.validationErrorResponse = response
        },
    },
}
